import { biLoggerFactory } from 'wix-private';

const msid = 'b68c0e3a-b4f3-4584-b73c-9eafbda35158';

const biGroupsLoggers = {
    19: biLoggerFactory('lp', 19, { msid }),
}

export async function fireBIEvent(src, evid, fields) {

    const biLogger = biGroupsLoggers[src];
    try {
        const biEventObject = {
            evid,
            ...fields
        };
        await biLogger.log(biEventObject);
    } catch (err) {
        console.error(`Failed to fireBIEvent -err- ${err}`);
    }
}